'use client';

import { getGlobalToast } from '@altus-ui/components_v2/v3/Toast';

export const toastFail = (message: string) => {
  const toast = getGlobalToast();
  if (toast) {
    toast.error(message);
  }
};
